import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// localStorage key — fallback para navegadores/contextos donde la cookie de
// sesión está bloqueada (Safari ITP cuando el frontend `gas2go.app` y el
// backend `*.emergent.host` no comparten eTLD+1). Después del login el
// backend devuelve `auth_token` en el body; lo guardamos aquí y lo
// mandamos como `Authorization: Bearer` en cada request.
export const AUTH_TOKEN_KEY = "gas2go:auth_token";
export const setAuthToken = (token) => {
  try {
    if (token) localStorage.setItem(AUTH_TOKEN_KEY, token);
    else localStorage.removeItem(AUTH_TOKEN_KEY);
  } catch (_e) { /* localStorage puede fallar en private mode */ }
};
export const getAuthToken = () => {
  try { return localStorage.getItem(AUTH_TOKEN_KEY) || ""; }
  catch (_e) { return ""; }
};

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Inyecta el token Bearer automáticamente en cada request si está presente.
// Mantenemos `withCredentials: true` para que la cookie también funcione
// cuando el navegador la respete (preview Emergent, mismo dominio).
api.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Algo salió mal.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const money = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(n) || 0);
